import _ from 'lodash'

import { NurserySettingsFormBuilder } from 'services/nurseries/models'

const injectValues = (data, keys, value) => {
  const newData = { ...data }

  if (1 === keys.length) {
    if (false === value) {
      newData[keys[0]] = true
    } else if (true === value) {
      delete newData[keys[0]]
    } else {
      newData[keys[0]] = value
    }
  }

  if (1 < keys.length) {
    const [key, ...restKeys] = keys

    if (!newData[key]) {
      newData[key] = {}
    }

    newData[key] = injectValues(newData[key], restKeys, value)

    if (_.isEmpty(newData[key])) {
      delete newData[key]
    }
  }

  return newData
}

const getNextNumericKey = (object) => {
  const numericKeys = []

  const extractKeys = (o) => {
    _.forOwn(o, (value, key) => {
      if (!isNaN(key)) numericKeys.push(Number(key))

      if (_.isObject(value) && !_.isArray(value)) {
        extractKeys(value)
      }
    })
  }

  extractKeys(object)

  return numericKeys.length ? Math.max(...numericKeys) + 1 : 0
}

const transformObject = (data, parent?) => (
  _.transform(data, (acc, value, key) => {
    if (_.isObject(value)) {
      // eslint-disable-next-line no-param-reassign
      acc[key] = transformObject(value, data)
    } else if (true === value && parent) {
      const nextKey = getNextNumericKey(acc)

      acc[String(nextKey)] = key
    }
  }, {})
)

export const getPayload = (formBuilderSettings: NurserySettingsFormBuilder, updatedValue: any) => {
  let finalPayload = { ...formBuilderSettings }

  if (_.isEmpty(finalPayload.fields)) {
    finalPayload.fields = {}
  }

  _.forEach(updatedValue, (value, key) => {
    const keys = _.split(key, '.')

    if (1 === keys.length) {
      finalPayload[keys[0]] = value
    } else {
      finalPayload = injectValues(finalPayload, keys, value)
    }
  })

  if (!finalPayload.fields || 0 === _.keys(finalPayload.fields).length) {
    finalPayload.fields = [] as any
  } else {
    finalPayload.fields = transformObject(finalPayload.fields)
  }

  if (!finalPayload.isTermsAndConditionsURL) {
    finalPayload.isTermsAndConditionsURL = false
  }

  if (!finalPayload.agreement) {
    finalPayload.agreement = ' '
  }

  if (!finalPayload.termsAndConditions) {
    finalPayload.termsAndConditions = ' '
  }

  if (!_.isBoolean(finalPayload.enrollmentDetails)) {
    finalPayload.enrollmentDetails = false
  }

  if (!_.isBoolean(finalPayload.includeBookingPattern)) {
    finalPayload.includeBookingPattern = false
  }

  if (!_.isNumber(finalPayload.maxParents)) {
    finalPayload.maxParents = 2
  }

  return finalPayload
}
